/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  GetProviderInfoErrorResponse,
  GetProviderInfoResponse,
  GetProviderParams,
} from './api.schemas';

import { api } from '../util/http';

export const getProvider = (
  providerId: string,
  params?: GetProviderParams,
  signal?: AbortSignal,
) => {
  return api<GetProviderInfoResponse>({
    url: `/api/provider/${providerId}`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetProviderQueryKey = (providerId?: string, params?: GetProviderParams) => {
  return [`/api/provider/${providerId}`, ...(params ? [params] : [])] as const;
};

export const getGetProviderQueryOptions = <
  TData = Awaited<ReturnType<typeof getProvider>>,
  TError = GetProviderInfoErrorResponse,
>(
  providerId: string,
  params?: GetProviderParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProvider>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProviderQueryKey(providerId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProvider>>> = ({ signal }) =>
    getProvider(providerId, params, signal);

  return { queryKey, queryFn, enabled: !!providerId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProvider>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProviderQueryResult = NonNullable<Awaited<ReturnType<typeof getProvider>>>;
export type GetProviderQueryError = GetProviderInfoErrorResponse;

export function useGetProvider<
  TData = Awaited<ReturnType<typeof getProvider>>,
  TError = GetProviderInfoErrorResponse,
>(
  providerId: string,
  params: undefined | GetProviderParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProvider>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProvider>>,
          TError,
          Awaited<ReturnType<typeof getProvider>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProvider<
  TData = Awaited<ReturnType<typeof getProvider>>,
  TError = GetProviderInfoErrorResponse,
>(
  providerId: string,
  params?: GetProviderParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProvider>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProvider>>,
          TError,
          Awaited<ReturnType<typeof getProvider>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProvider<
  TData = Awaited<ReturnType<typeof getProvider>>,
  TError = GetProviderInfoErrorResponse,
>(
  providerId: string,
  params?: GetProviderParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProvider>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetProvider<
  TData = Awaited<ReturnType<typeof getProvider>>,
  TError = GetProviderInfoErrorResponse,
>(
  providerId: string,
  params?: GetProviderParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProvider>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProviderQueryOptions(providerId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
